// test1790
(1790 && 0);
